import { Select } from '@warp-ds/react/components/select';
import type { ChangeEvent } from 'react';
import type { ApiQueryParams } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

const originAirports: Record<string, string> = displayValues.originAirports;

export interface OriginDropdownProps {
    selectedValue: string;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
    filterChange: (newOriginAirportValue: string) => void;
}

export const OriginDropdown = ({ selectedValue, filterChange, triggerFetch }: OriginDropdownProps) => {
    const onChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        filterChange(event.target.value);
        triggerFetch();
    };

    return (
        <Select label="Reis fra" value={selectedValue} onChange={onChange} data-testid="originDropdown">
            {Object.keys(originAirports).map((origin: string) => (
                <option key={origin} value={origin}>
                    {originAirports[origin]}
                </option>
            ))}
        </Select>
    );
};
